import {Action, getModule, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import store from '@/store';

export interface ILocationStoreState {
	location: ILocation | null;
}

export interface ILocation {
	locationId: string;
	name: string;
	address: string;
	phone: string;
	defaultOrderNotes: string[];
	isOrderingAvailable: boolean;
}


@Module({dynamic: true, store, name: 'location', namespaced: true})
class Location extends VuexModule implements ILocationStoreState {
	location: ILocation | null = null;

	get defaultOrderNotes() {
		if(this.location === null) {
			return [];
		}
		return this.location.defaultOrderNotes;
	}

	@Action
	public addOrUpdateLocation(location: ILocation) {
		this.ADD_OR_UPDATE_LOCATION(location);
	}

	@Action
	public clearLocation() {
		this.CLEAR_LOCATION();
	}


	@Mutation
	public ADD_OR_UPDATE_LOCATION(locations: ILocation) {
		this.location = locations;
	}

	@Mutation
	public CLEAR_LOCATION() {
		this.location = null;
	}
}

export const LocationStore = getModule(Location);
